import { Output, Component, EventEmitter, Input, OnChanges, SimpleChanges, ANALYZE_FOR_ENTRY_COMPONENTS } from "@angular/core";
import { NgbDateStruct, NgbDatepicker } from "@ng-bootstrap/ng-bootstrap";
import { UserActivityLogger, UserActivityLoggerOptions } from "../../instrumentation/user-activity-logger.service";
import { ResortDetailsPageEvents } from "../../instrumentation/resort-custom-events";
import { QueryParamService, Selectable } from "../../shared/core/ovs.core";
import { UnitType } from "./unit-type.model";
import { RoomFilter } from "./room-filter.model";
import { RoomFilterChangeTypes } from "./room-filter-change-types.enum";
import { DateChangeInfo } from "./room-filter-change-info.model";

export class RoomFilterCommon implements OnChanges{

    @Input()
    public reset: boolean;

    @Input()
    public noSearchResults: boolean;
    @Input()
    public roomFilter: RoomFilter;
    
    public selectedDate: NgbDateStruct;
    @Output()
    public roomFilterUpdated: EventEmitter<any> = new EventEmitter();

    @Output()
    public filterUpdated: EventEmitter<any> = new EventEmitter();

    private _previousDate: Date = null;
    protected qryParamService:QueryParamService;
    public selectedPrice: number;
    
    public initialize(){
        let initialStartDate: Date = this.qryParamService.resortDetailParams.startDate;
        this.selectedDate = <NgbDateStruct>{ year: initialStartDate.getFullYear(), month: initialStartDate.getMonth() + 1, day: initialStartDate.getDate() };
    }

    public onSelectedDateChanged(newDate: NgbDateStruct): void 
    {
        const date = new Date(this.selectedDate.year, this.selectedDate.month - 1, this.selectedDate.day);
        if(this._previousDate!== null && this._previousDate !== date) {
            UserActivityLogger.logEvent(ResortDetailsPageEvents.AvailabilityModalDateFilterApplied, { filter: "checkInDate" }, UserActivityLoggerOptions.AppInsightsOnly);
        }
        this._previousDate = date;
        
        const changeInfo = new DateChangeInfo();
        changeInfo.date = date;
        this.roomFilterUpdated.emit(changeInfo);
    }

    public onRoomSelectionChanged(unitType: UnitType) {
        const count = this.roomFilter.unitTypes.where(u => u.isSelected).count();

        if(count < 1){
            unitType.isSelected = true;
        }
        else{
            this.filterUpdated.emit(this.currentRoomFilter);
        }
    }

    public get currentRoomFilter(): RoomFilter{
        const roomFilter = new RoomFilter();
        roomFilter.unitTypes = this.roomFilter.unitTypes.where(r => r.isSelected).toArray();
        roomFilter.nights = this.roomFilter.nights.where(n => n.isSelected).toArray();
        roomFilter.maxPrice = this.selectedPrice;
        //TODO: filter within days of search date
        //roomFilter.withinDaysOfSelectedDate = this.roomFilter.withinDaysOfSelectedDate;
        return roomFilter;
    }

    public get onlyOneRoomSelected(): boolean {
        const count = this.roomFilter.unitTypes.where(f => f.isSelected).count() === 1;
        return count;
    }

    public get onlyOneNightOptionSelected(): boolean{
        return this.roomFilter.nights.where(f => f.isSelected).count() === 1;
    }

    public onNightsSelectionChanged(night: Selectable<number>):void {

        const count = this.roomFilter.nights.where(f => f.isSelected).count();

        if(count < 1){
            night.isSelected = true;
        }
        else{
            this.filterUpdated.emit(this.currentRoomFilter);
        }
    }

    //TODO: filter within days of search date
    //public onWithinSelectionChanged(within: Selectable<number>): void {

        //let count: number = this.roomFilter.withinDaysOfSelectedDate;

        //if (count < 1) {
            //within.isSelected = true;
        //}
       //else {
            //this.filterUpdated.emit(this.currentRoomFilter);
        //}
    //}

    public onSelectedPriceChanged(d:any):void{
        this.selectedPrice = d.value;
        this.filterUpdated.emit(this.currentRoomFilter);
    }

    ngOnChanges(changes: SimpleChanges) {
       if(changes.roomFilter && !changes.roomFilter.firstChange) this.onMixMaxChanged();

       if(changes.reset) this.selectedPrice = this.roomFilter.maxPrice;
    }

    public onMixMaxChanged(){
        this.selectedPrice = this.roomFilter.maxPrice;
    }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/room-availability/room-availability-v2/room-filter.common.ts